import { getAdapterLocale } from "../components/ShadowUtils";
import { useLanguage } from "../components/Language";
import * as dayjs from "dayjs";

dayjs.locale(getAdapterLocale());

export function useLocalizedShortDate() {
  const { localizedShortDateFormat } = useLanguage();
  return (date?: dayjs.ConfigType) =>
    dayjs(date).format(localizedShortDateFormat);
}
